import { gql } from '@apollo/client';
import { ERRORS_FRAGMENT, IMAGE_FRAGMENT } from '@/graphql/fragments';

export const CONTACT_CARD_INFO_QUERY = gql`
    ${ERRORS_FRAGMENT}
    ${IMAGE_FRAGMENT}
    query ContactCardInfo($token: String!) {
        contactCardInfo(token: $token) {
            status
            errors {
                ...ErrorType
            }
            object {
                id
                fullName
                email
                phoneStaff
                agency
                image {
                    ...ImageType
                }
            }
        }
    }
`;
